/* =============================================================
   customer-review.js  —  Tiroflx Verified Review
   Firebase Firestore + Storage backend
   Drop this file into: Online Store > Themes > Edit code >
   Assets > customer-review.js  (replace existing)
   ============================================================= */

/* ── 1. FIREBASE CONFIG ──────────────────────────────────────
   Replace every value below with your own project credentials.
   Firebase Console → Project Settings → Your apps → Web app
   ─────────────────────────────────────────────────────────── */
const FIREBASE_CONFIG = {
  apiKey:            "AIzaSyCu44Ze9wqiZrLkMUEQOhgDZ0cLaTm04pg",
  authDomain:        "tiroflx.firebaseapp.com",
  projectId:         "tiroflx",
  storageBucket:     "tiroflx.firebasestorage.app",
  messagingSenderId: "793290865992",
  appId:             "1:793290865992:web:2cfb3b98c18cd48b63077d"
};

/* ── 2. COLLECTION NAME ──────────────────────────────────────
   This is the Firestore collection where reviews are stored.
   ─────────────────────────────────────────────────────────── */
const COLLECTION = "reviews";

/* ── 3. BOOTSTRAP FIREBASE (CDN — no npm needed) ─────────────
   We load Firebase v9 compat from CDN so it works inside
   Shopify without a build step.
   ─────────────────────────────────────────────────────────── */
(function loadFirebase() {
  const scripts = [
    "https://www.gstatic.com/firebasejs/10.12.0/firebase-app-compat.js",
    "https://www.gstatic.com/firebasejs/10.12.0/firebase-firestore-compat.js",
    "https://www.gstatic.com/firebasejs/10.12.0/firebase-storage-compat.js"
  ];

  let loaded = 0;
  scripts.forEach(src => {
    const s = document.createElement("script");
    s.src = src;
    s.onload = () => { if (++loaded === scripts.length) initApp(); };
    s.onerror = () => console.error("[TiroflxReview] Failed to load", src);
    document.head.appendChild(s);
  });
})();

/* ── 4. APP INIT ─────────────────────────────────────────────*/
function initApp() {
  if (!firebase.apps.length) firebase.initializeApp(FIREBASE_CONFIG);
  const db      = firebase.firestore();
  const storage = firebase.storage();

  /* ── DOM refs ───────────────────────────────────────────── */
  const wrap        = document.getElementById("cr-main");
  const successBox  = document.getElementById("cr-success");
  const form        = document.getElementById("cr-form");
  const submitBtn   = document.getElementById("submit-btn");
  const photoInput  = document.getElementById("photo-input");
  const dropZone    = document.getElementById("drop-zone");
  const previewsEl  = document.getElementById("photo-previews");
  const photoCount  = document.getElementById("photo-count");
  const starRow     = document.getElementById("star-row");
  const tsEl        = document.getElementById("live-timestamp");

  /* ── State ──────────────────────────────────────────────── */
  let selectedRating = 0;
  let selectedFiles  = [];

  /* ── URL params (pre-fill) ──────────────────────────────── */
  const params = new URLSearchParams(window.location.search);
  const paramName    = params.get("name")    || "";
  const paramEmail   = params.get("email")   || "";
  const paramProduct = params.get("product") || "";
  const paramUID     = params.get("uid")     || "";

  /* Populate display fields */
  setText("meta-name",    paramName    || "—");
  setText("meta-id",      paramUID     || "—");
  setText("meta-product", paramProduct || "—");
  setText("display-uid",  paramUID     || "—");

  /* Pre-fill form inputs */
  setValue("field-name",    paramName);
  setValue("field-email",   paramEmail);
  setValue("field-product", paramProduct);

  /* ── Live timestamp ─────────────────────────────────────── */
  function updateTimestamp() {
    if (tsEl) tsEl.textContent = new Date().toLocaleString();
  }
  updateTimestamp();
  setInterval(updateTimestamp, 1000);

  /* ── Star rating ────────────────────────────────────────── */
  if (starRow) {
    const stars = starRow.querySelectorAll(".cr-star");

    stars.forEach(star => {
      star.addEventListener("click", () => {
        selectedRating = parseInt(star.dataset.val, 10);
        stars.forEach(s =>
          s.classList.toggle("cr-star--active", parseInt(s.dataset.val, 10) <= selectedRating)
        );
        hideErr("err-stars");
      });

      star.addEventListener("keydown", e => {
        if (e.key === "Enter" || e.key === " ") star.click();
      });
    });
  }

  /* ── Photo upload ───────────────────────────────────────── */
  if (photoInput) {
    photoInput.addEventListener("change", e => {
      addFiles(Array.from(e.target.files));
      photoInput.value = "";
    });
  }

  if (dropZone) {
    dropZone.addEventListener("dragover", e => { e.preventDefault(); dropZone.classList.add("cr-upload-zone--over"); });
    dropZone.addEventListener("dragleave",  () => dropZone.classList.remove("cr-upload-zone--over"));
    dropZone.addEventListener("drop", e => {
      e.preventDefault();
      dropZone.classList.remove("cr-upload-zone--over");
      addFiles(Array.from(e.dataTransfer.files).filter(f => f.type.startsWith("image/")));
    });
  }

  function addFiles(files) {
    files.forEach(f => {
      if (selectedFiles.length >= 10) return;
      if (!f.type.startsWith("image/")) return;
      selectedFiles.push(f);
    });
    renderPreviews();
    hideErr("err-photos");
  }

  function renderPreviews() {
    if (!previewsEl) return;
    previewsEl.innerHTML = "";
    selectedFiles.forEach((f, i) => {
      const url  = URL.createObjectURL(f);
      const wrap = document.createElement("div");
      wrap.className = "cr-preview-thumb";
      wrap.innerHTML = `
        <img src="${url}" alt="Preview ${i + 1}" />
        <button type="button" class="cr-preview-remove" aria-label="Remove photo ${i + 1}" data-idx="${i}">✕</button>
      `;
      previewsEl.appendChild(wrap);
    });
    previewsEl.querySelectorAll(".cr-preview-remove").forEach(btn => {
      btn.addEventListener("click", () => {
        selectedFiles.splice(parseInt(btn.dataset.idx, 10), 1);
        renderPreviews();
      });
    });
    if (photoCount) {
      photoCount.textContent = selectedFiles.length
        ? `${selectedFiles.length} photo${selectedFiles.length > 1 ? "s" : ""} selected`
        : "";
    }
  }

  /* ── Upload photos to Firebase Storage ──────────────────── */
  async function uploadPhotos(uid, timestamp) {
    const urls = [];
    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];
      const ext  = file.name.split(".").pop() || "jpg";
      const path = `reviews/${uid}_${timestamp}_${i}.${ext}`;
      const ref  = storage.ref(path);
      await ref.put(file);
      const url = await ref.getDownloadURL();
      urls.push(url);
    }
    return urls;
  }

  /* ── Form submit ────────────────────────────────────────── */
  if (form) {
    form.addEventListener("submit", async e => {
      e.preventDefault();
      if (!validate()) return;

      setSubmitting(true);

      try {
        const timestamp = new Date().toISOString();
        const uid = paramUID || `ANON-${Date.now()}`;

        /* Upload photos first */
        const photoURLs = selectedFiles.length
          ? await uploadPhotos(uid, Date.now())
          : [];

        /* Build review document */
        const review = {
          /* From URL params */
          uid,
          /* From form */
          name:    getValue("field-name"),
          email:   getValue("field-email"),
          product: getValue("field-product") || paramProduct,
          /* Delivery confirmation */
          deliveryConfirmed:    isChecked("check1"),
          arrivedGoodCondition: isChecked("check2"),
          satisfiedWithPurchase: isChecked("check3"),
          /* Review content */
          rating:  selectedRating,
          review:  getValue("field-review"),
          /* Photos */
          photos: photoURLs,
          photoCount: photoURLs.length,
          /* Meta */
          store:      "Tiroflx",
          storeURL:   "tiroflx.net",
          submittedAt: timestamp,
          createdAt:   firebase.firestore.FieldValue.serverTimestamp(),
          verified:    true,
          source:      "verified-review-page"
        };

        /* Save to Firestore */
        const docRef = await db.collection(COLLECTION).add(review);
        console.log("[TiroflxReview] Saved:", docRef.id);

        /* Show success screen */
        showSuccess(review, photoURLs.length);

      } catch (err) {
        console.error("[TiroflxReview] Submit error:", err);
        alert("Something went wrong. Please try again.\n\n" + err.message);
        setSubmitting(false);
      }
    });
  }

  /* ── Validation ─────────────────────────────────────────── */
  function validate() {
    let ok = true;

    if (!getValue("field-name").trim()) { showErr("err-name");   ok = false; }
    else hideErr("err-name");

    const email = getValue("field-email").trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { showErr("err-email"); ok = false; }
    else hideErr("err-email");

    if (!isChecked("check1") || !isChecked("check2") || !isChecked("check3")) {
      showErr("err-checks"); ok = false;
    } else hideErr("err-checks");

    if (!selectedRating) { showErr("err-stars");  ok = false; }
    else hideErr("err-stars");

    if (getValue("field-review").trim().length < 20) { showErr("err-review"); ok = false; }
    else hideErr("err-review");

    if (!selectedFiles.length) { showErr("err-photos"); ok = false; }
    else hideErr("err-photos");

    return ok;
  }

  /* ── Success screen ─────────────────────────────────────── */
  function showSuccess(review, photoCount) {
    if (wrap)       wrap.hidden = true;
    if (successBox) successBox.hidden = false;

    setText("proof-name",      review.name);
    setText("proof-email",     review.email);
    setText("proof-product",   review.product || "—");
    setText("proof-uid",       review.uid);
    setText("proof-stars",     "★".repeat(review.rating) + "☆".repeat(5 - review.rating));
    setText("proof-photos",    `${photoCount} photo${photoCount !== 1 ? "s" : ""}`);
    setText("proof-timestamp", review.submittedAt);
  }

  /* ── Helpers ────────────────────────────────────────────── */
  function getText(id)        { return document.getElementById(id); }
  function setText(id, val)   { const el = getText(id); if (el) el.textContent = val; }
  function getValue(id)       { const el = getText(id); return el ? el.value : ""; }
  function setValue(id, val)  { const el = getText(id); if (el && val) el.value = val; }
  function isChecked(id)      { const el = getText(id); return el ? el.checked : false; }
  function showErr(id)        { const el = getText(id); if (el) el.style.display = "block"; }
  function hideErr(id)        { const el = getText(id); if (el) el.style.display = "none"; }

  function setSubmitting(submitting) {
    if (!submitBtn) return;
    submitBtn.disabled = submitting;
    submitBtn.textContent = submitting ? "Submitting…" : "Submit verified review";
  }
}